<template>
    <v-container>
        <v-layout column class="ma-0 pa-0">
            <v-text-field v-model="stampanteSel" label="indirizzo IP stampante" />
            <v-btn color="primary" @click="stampaEtichetta()"> Stampa etichetta lotto</v-btn>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            stampanteSel: "192.168.90.188"
        };
    },
    methods: {
        async stampaEtichetta() {
            try {
                let zpl = "^XA^MCY^XZ^XA^FWN^CFD,24^PW799^LH0,0^CI0^PR2^MNY^MTT^MMT^MD15^PON^PMN^LRN^XZ^XA^MCY^XZ^XA^DFE:DOCUMENT.ZPL^LRN^A0N,70,90^FO45,10^FDECO 10015 03 95 00^FS^A0N,24,28^FO220,90^FB550,3,1,L,0^FDGlasgow 'Cromato Satinato' Solo Impugnatura Ambidestra (VASETTO BASSO) ^FS^A0N,36,36^FO220,195^FDMAGLAS8C16XNZC02M6 VB^FS^BY2.3,2.0,7^A0N,24,22^FO650,240^FDPezzi 560^FS^BY2.3,2.0,7^FO50,70^BQN,2,6^FDMM,AECO10015039500/FR-23-29-001^FS^A0N,24,22^FO50,240^FDFR-23-29-001^FS^FW^XZ^XA^XFE:DOCUMENT.ZPL^PQ1,0,1,Y^XZ";
                const axios = require('axios');
                const url = "http://" + this.stampanteSel + "/pstprnt";
                const response = await axios.post(url, zpl);
                console.log('API call response:', response.data);
            } catch (error) {
                console.error(error);
            }
        },
    },
}

</script>